import Notifications from "@/managers/session/notifications"

declare global {
	interface Window {
		dataLayer: any[]
	}
}

class GlobalSiteTag {
	public userId: string | null = null
	private isInitialized = false

	constructor() {
		this.initialize()
	}

	public setUserId(userId: string | null): void {
		this.gtag({"user_id": userId ?? undefined})
	}

	public setCanTrack(canTrack: boolean): void {
		this.updateConsent(false, canTrack)
	}

	public logEvent(name: string, data: {[key: string]: any}): void {
		this.gtag("event", name, data)
	}

	public logGTMEvent(name: string, data: { [key: string]: any }): void {
		this.gtag({event: name, ...data})
	}

	private initialize(): void {
		if (this.isInitialized)
			return
		this.isInitialized = true

		try {
			window.dataLayer = window.dataLayer || []
			this.updateConsent(true, false)
			this.gtag("set", "send_page_view", true)
		} catch (error: any) {
			if (error instanceof Error)
				Notifications.warning("Failed to initialize analytics", error)
			else
				Notifications.warning("Failed to initialize analytics: " + error?.toString())
		}
	}

	private gtag(...args: any[]): void {
		try {
			window.dataLayer.push(arguments) // Has to use arguments, NOT args, for gtag to work
		} catch (error: any) {
			if (error instanceof Error)
				Notifications.warning("Failed to call analytics", error)
			else
				Notifications.warning("Failed to call analytics: " + error?.toString())
		}
	}

	private updateConsent(setDefault: boolean, granted: boolean): void {
		this.gtag("consent", setDefault ? "default" : "update", this.createConsentOptions(granted))
	}

	private createConsentOptions(granted: boolean): object {
		return {
			"ad_storage": granted ? "granted" : "denied",
			"ad_user_data": granted ? "granted" : "denied",
			"ad_personalization": granted ? "granted" : "denied",
			"analytics_storage": granted ? "granted" : "denied"
		}
	}
}

export default new GlobalSiteTag()
